<template>
<div>

  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 px-2">
        <div class="box">

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="code">
                Code
              </label>
              <input
                name="code"
                type="text"
                id="code"
                class="form-control"
                v-model="product.code"
              >
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="name">
                Name <span class="text-red-500">*</span>
              </label>
              <ValidationProvider
                rules="required"
                name="name"
                v-slot="{ errors }"
              >
                <input
                  name="name"
                  type="text"
                  id="name"
                  class="form-control"
                  v-model="product.name"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="type">
                Type <span class="text-red-500">*</span>
              </label>

              <ValidationProvider
                rules="required"
                name="type"
                v-slot="{ errors }"
              >
                <div class="relative">
                  <select
                    name="type"
                    class="form-control pr-8"
                    id="type"
                    v-model="product.type"
                  >
                    <option></option>
                    <option :value="t" v-for="(t, i) in config.productTypes" :key="'product-types-' + i">{{ t | sentenceCase }}</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="stock">
                Stock
              </label>
              <ValidationProvider
                rules="decimal"
                name="stock"
                v-slot="{ errors }"
              >
                <input
                  name="stock"
                  type="text"
                  id="stock"
                  class="form-control"
                  v-model="product.stock"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <p class="text-xl font-bold mt-4">PRICING</p>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="purchase-price">
                Purchase price <span class="text-red-500">*</span>
              </label>
              <ValidationProvider
                rules="required|currency"
                name="purchase price"
                v-slot="{ errors }"
              >
                <div class="flex mt-4 items-center">
                  <div class="h-10 px-2 py-2 rounded-l border border-r-0 border-theme-200 light:border-theme-600 focus:outline-none">
                    {{ config.currency }}
                  </div>
                  <input
                    name="purchase_price"
                    type="text"
                    id="purchase-price"
                    class="form-control form-no-outline h-10 rounded-l-none"
                    v-model="product.purchase_price"
                  >
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="purchase-price">
                Purchase tax <span class="text-red-500">*</span>
              </label>

              <ValidationProvider
                rules="required|decimal"
                name="purchase tax"
                v-slot="{ errors }"
              >
                <div class="flex mt-4 items-center">
                  <input
                    name="purchase_tax"
                    type="text"
                    id="purchase-tax"
                    class="form-control form-no-outline h-10 rounded-r-none"
                    placeholder=""
                    v-model="product.purchase_tax"
                  >
                  <div class="h-10 px-2 py-2 rounded-r border border-l-0 border-theme-200 light:border-theme-600 focus:outline-none">
                    %
                  </div>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="sale-price">
                Sale price <span class="text-red-500">*</span>
              </label>
              <ValidationProvider
                rules="required|currency"
                name="sale price"
                v-slot="{ errors }"
              >
                <div class="flex mt-4 items-center">
                  <div class="h-10 px-2 py-2 rounded-l border border-r-0 border-theme-200 light:border-theme-600 focus:outline-none">
                    {{ config.currency }}
                  </div>
                  <input
                    name="sale_price"
                    type="text"
                    id="sale-price"
                    class="form-control form-no-outline h-10 rounded-l-none"
                    v-model="product.sale_price"
                  >
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="sale-price">
                Sale tax <span class="text-red-500">*</span>
              </label>
                <ValidationProvider
                  rules="required|decimal"
                  name="sale tax"
                  v-slot="{ errors }"
                >
                  <div class="flex mt-4 items-center">
                    <input
                      name="sale_tax"
                      type="text"
                      id="sale-tax"
                      class="form-control form-no-outline h-10 rounded-r-none"
                      placeholder=""
                      v-model="product.sale_tax"
                    >
                    <div class="h-10 px-2 py-2 rounded-r border border-l-0 border-theme-200 light:border-theme-600 focus:outline-none">
                      %
                    </div>
                  </div>
                  <span class="text-sm text-red-500">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
          </div>

        </div>
      </div>
      <div class="w-full md:w-1/2 px-2">
        <edit-supplier
          :show-mass-settle-tab="false"
          :show-statement-tab="false"
          :full-width-cols="true"
          :show-supplier-info="false"
          :selectable="true"
          :supplierAccountID="product.supplier_account_id"
          @selected="selectSupplierAccount($event)"
          :inModal="inModal"
          :supplierID="supplierID"
          :select-required="false"
        ></edit-supplier>
      </div>
    </div>
  </ValidationObserver>


  <div class="box py-2">
    <div class="box p-0 pt-4 flex flex-wrap justify-end items-center">
      <button
        type="button"
        class="btn btn-reset"
        @click="reset"
      >
        <i class="fa-xs fas fa-undo"></i>
        <span class="ml-1">RESET</span>
      </button>
      <button
        type="button"
        class="btn btn-save"
        @click="save"
      >
        <i class="fa-xs fas fa-check"></i>
        <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
      </button>
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios'
import path from 'path'
const EditSupplier = resolve => require(['@/components/pages/suppliers/Details'], resolve)
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'product-edit',
  components: {
    EditSupplier,
  },
  props: {
    productID: {},
    modelOptions: {},
    createAlert: {
      type: Boolean,
      default: true,
    },
    inModal: Boolean,
  },
  data() {
    return {
      mode: null,
      editID: null,
      supplierID: null,
      showSelectSupplier: true,
      product: {},
    }
  },
  watch: {
    productID() {
      this.setMode()
    },
    modelOptions() {
      this.checkModelOptions()
    },
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    if (!this.config.productTypes.length) {
      this['config/getProductTypes']()
    }
    this.setMode()

    this.$EventBus.$on('supplierAccount.selected', (account) => this.selectSupplierAccount(account))
  },
  destroyed() {
    this.$EventBus.$off('supplierAccount.selected')
  },
  methods: {
    checkModelOptions() {
      if (Object.entries(this.modelOptions).length > 0) {
        // check for supplier
        if (this.modelOptions.supplierID) {
          this.supplierID = this.modelOptions.supplierID
        }
        if (this.modelOptions.supplierAccountID) {
          this.product.supplier_account_id = this.modelOptions.supplierAccountID
        }
        if (this.modelOptions.supplierID && this.modelOptions.supplierAccountID) {
          this.showSelectSupplier = false
        }
      }
    },
    selectSupplierAccount(account) {
      this.product.supplier_account_id = account ? account.id : null
    },
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'product' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.productID) {
        this.editID = this.productID
        this.mode = 'edit'
      } else if (this.$route.params.productID) {
        this.editID = this.$route.params.productID
      }

      if (this.mode === 'create') {
        this.product = this.emptyProduct()
      } else {
        // get product
        this.get()
      }
    },
    emptyProduct() {
      return {
        supplier_account_id: null,
        code: '',
        name: '',
        type: '',
        stock: '',
        purchase_price: '',
        purchase_tax: this.config.defaultTaxPercentage,
        sale_price: '',
        sale_tax: this.config.defaultTaxPercentage,
      }
    },
    get() {
      return new Promise((resolve, reject) => {
        axios.get(path.join('products', String(this.editID)))
          .then((response) => {
            const product = response.data
            this.product = Object.assign({}, product)
            this.editSupplierAccountID = this.product.supplier_account_id
            resolve(product)
          })
          .catch((error) => reject(error))
      })
    },
    set(product) {
      this.product = Object.assign({}, this.product, product)
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.product = this.emptyProduct()
            } else {
              this.get()
            }
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // create / update
      // check if supplier_id was selected
      if (!this.product.supplier_account_id && this.product.type !== 'labour' && this.product.type !== 'discount') {
        this.$swal.fire('Please select supplier account', '', 'warning')
        return
      }

      if (this.mode === 'create') {
        axios.post('products', this.product)
          .then((response) => {
            const newProduct = response.data

            // reset product (for when modals re-open)
            this.product = Object.assign({}, this.emptyProduct())
            this.$emit('created', newProduct)
            this.$EventBus.$emit('supplier.deselect')

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Product created successfully!',
                type: 'success',
                confirmButtonText: 'Show me',
                showCancelButton: true,
                cancelButtonText: 'Create more',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push('/product/details/' + newProduct.id)
                  } else {
                    this.product = Object.assign({}, this.emptyProduct())
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put(path.join('products', String(this.product.id)), this.product)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Product updated successfully!',
              type: 'success',
            })

            this.get()
            this.$emit('updated', this.product)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    ...mapActions([
      'config/getProductTypes',
    ])
  }

}
</script>
